import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

let theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000",
      light: "#FFF",
    },
    background: {
      white: "#FFF",
      drawer: "rgba(0, 97, 120, 0.95)",
    },
    button: {
      main: "#ee1d1b",
      secondary: "#f25e74",
    },
    border: {
      main: "#ced4da",
      dark: "#000",
    },
    text: {
      primary: "#000000",
      secondary: "#fff",
      alternative: "#666a6c",
    },
  },
  borderRadius: {
    default: "4px",
  },
  typography: {
    fontFamily: "'source-sans-pro', sans-serif",
    fontWeightBold: 700,
    fontWeightMedium: 500,
    h1: {
      fontSize: "1.875rem",
      fontWeight: 900,
      marginLeft: "1.5rem",
    },
    h2: {
      fontSize: "1.875rem",
      fontWeight: 900,
    },
    h3: {
      fontSize: "1.25rem",
      marginLeft: "1.5rem",
      marginBottom: "1rem",
      fontWeight: 600,
      color: "rgb(74, 74, 74)",
    },
    body1: {
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      fontSize: "1em",
    },
  },
  zIndex: {
    content: 100,
    phoneNumber: 200,
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "#fff",
        },
      },
    },
    MuiButton: {
      textSecondary: {
        color: "rgb(102, 106, 108)",
        backgroundColor: "#fff",
        textDecoration: "underline",
        textTransform: "none",
        fontSize: "1rem",
        "&:hover": {
          backgroundColor: "#fff",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
